"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var ArrowIndicatorLeftOutline_1 = __importDefault(require("../icons/generated/ArrowIndicatorLeftOutline"));
var NavigationWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 1rem;\n  display: flex;\n  align-items: center;\n  color: ", ";\n\n  svg {\n    width: 1.25rem;\n    height: 1.25rem;\n    fill: ", ";\n  }\n\n  span {\n    font-size: 1.25rem;\n    position: absolute;\n    left: 50%;\n    transform: translate(-50%, 0);\n  }\n"], ["\n  margin-bottom: 1rem;\n  display: flex;\n  align-items: center;\n  color: ", ";\n\n  svg {\n    width: 1.25rem;\n    height: 1.25rem;\n    fill: ", ";\n  }\n\n  span {\n    font-size: 1.25rem;\n    position: absolute;\n    left: 50%;\n    transform: translate(-50%, 0);\n  }\n"])), function (_a) {
    var colours = _a.theme.colours;
    return colours.backNavigation.color;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.backNavigation.color;
});
var BackNavigation = function (_a) {
    var name = _a.name, onClick = _a.onClick;
    return (react_1.default.createElement(NavigationWrapper, null,
        react_1.default.createElement(ArrowIndicatorLeftOutline_1.default, { onClick: onClick }),
        react_1.default.createElement("span", null, name)));
};
exports.default = BackNavigation;
var templateObject_1;
//# sourceMappingURL=back-navigation.component.js.map